// A file dedicated to store functions that can be used throughout the project
// can probably be reorganized based on which product feature each function is specific to

import { allCompaniesFields } from "../components/datatable/companies/field-configs";
import { allInvestorsFields } from "../components/datatable/investors/field-configs";

// make new fields array with reference to the allfields array in the field-config file

export const getCompaniesFieldsArray = (keys, stickyField) => {
  return keys.map((field, index) => ({
    actualName: field,
    displayName:
      allCompaniesFields[
        allCompaniesFields.findIndex((e) => e.actualName === field)
      ].displayName,
    // if field sticky add sticky classname
    cName: [
      allCompaniesFields[
        allCompaniesFields.findIndex((e) => e.actualName === field)
      ].cName,
      field === stickyField ? "sticky" : "",
    ].join(" "),
    type: allCompaniesFields[
      allCompaniesFields.findIndex((e) => e.actualName === field)
    ].type,
  }));
};

// make new fields array with reference to the allfields array in the field-config file
export const getInvestorsFieldsArray = (keys, stickyField) => {
  return keys.map((field, index) => ({
    actualName: field,
    displayName:
      allInvestorsFields[
        allInvestorsFields.findIndex((e) => e.actualName === field)
      ].displayName,
    cName: [
      allInvestorsFields[
        allInvestorsFields.findIndex((e) => e.actualName === field)
      ].cName,
      field === stickyField ? "sticky" : "",
    ].join(" "),
    type: allInvestorsFields[
      allInvestorsFields.findIndex((e) => e.actualName === field)
    ].type,
  }));
};

// datatable pages
export const getNewHeader = (collection, header) => {
  //update the argument state variable
  let newHeader;

  if (collection === "investors") {
    switch (header) {
      case "name": {
        newHeader = "name";
        break;
      }
      case "description": {
        newHeader = "description";
        break;
      }
      case "numOfFailedInvestments": {
        newHeader = "numOfFailedInvestments";
        break;
      }
      case "shutteredPortfolioCompanies": {
        newHeader = "shutteredPortfolioCompanies";
        break;
      }
      case "reputation": {
        newHeader = "reputation";
        break;
      }
      case "investmentStage": {
        newHeader = "investmentStage";
        break;
      }
      case "investmentGeography": {
        newHeader = "investmentGeography";
        break;
      }
      case "numOfInvestments": {
        newHeader = "numOfInvestments";
        break;
      }
      case "numOfLeadInvestments": {
        newHeader = "numOfLeadInvestments";
        break;
      }
      case "numOfFollowOnInvestments": {
        newHeader = "numOfFollowOnInvestments";
        break;
      }
      case "numOfCoInvestments": {
        newHeader = "numOfCoInvestments";
        break;
      }
      case "numOfAcquisitions": {
        newHeader = "numOfAcquisitions";
        break;
      }
      case "boardSeats": {
        newHeader = "boardSeats";
        break;
      }
      case "limitedPartners": {
        newHeader = "limitedPartners";
        break;
      }
      case "coInvestors": {
        newHeader = "coInvestors";
        break;
      }
      case "numofPartners": {
        newHeader = "numofPartners";
        break;
      }
      case "partners": {
        newHeader = "partners";
        break;
      }
      case "socialMedia": {
        newHeader = "socialMedia";
        break;
      }
      case "entityType": {
        newHeader = "entityType";
        break;
      }
      case "legalName": {
        newHeader = "legalName";
        break;
      }
      case "numOfFunds": {
        newHeader = "numOfFunds";
        break;
      }
      case "assets": {
        newHeader = "assets";
        break;
      }
      case "location": {
        newHeader = "location.city";
        break;
      }
      case "investmentRange": {
        newHeader = "investmentRange.totalNumOfStages";
        break;
      }
      case "investmentTrackRecord": {
        newHeader = "investmentTrackRecord.totalNumOfStages";
        break;
      }
      case "investmentFocus": {
        newHeader = "investmentFocus";
        break;
      }
      case "sweetSpot": {
        newHeader = "sweetSpot.totalNumOfStages";
        break;
      }
      case "management": {
        newHeader = "management.name";
        break;
      }
      case "boardMembers": {
        newHeader = "boardMembers.firstName";
        break;
      }
      case "lossOnInvestments": {
        newHeader = "lossOnInvestmentsObj.int";
        break;
      }
      case "numOfEmployeesObj": {
        newHeader = "numOfEmployeesObj.min";
        break;
      }
      case "website": {
        newHeader = "profileLink.url";
        break;
      }
      case "founded": {
        newHeader = "founded.dateOrder";
        break;
      }
      case "email": {
        newHeader = "contact.emails";
        break;
      }
      case "phone": {
        newHeader = "contact.phoneNumber";
        break;
      }
      case "address": {
        newHeader = "address.street1";
        break;
      }
      case "formerlegalName": {
        newHeader = "former_legalName";
        break;
      }
      case "stockSymbol": {
        newHeader = "stockSymbol";
        break;
      }
      default: {
        newHeader = header;
      }
    }
  } else {
    switch (header) {
      case "lastFinancingRound": {
        newHeader = "details.lastFinancingRound";
        break;
      }
      case "totalInvestment": {
        newHeader = "details.totalInvestment.totalRaised";
        break;
      }
      case "location": {
        newHeader = "details.location.city";
        break;
      }
      case "numOfFundingRounds": {
        newHeader = "details.numOfFundingRounds";
        break;
      }
      case "numOfInvestors": {
        newHeader = "details.numOfInvestors.total";
        break;
      }
      case "numOfAcquisitions": {
        newHeader = "details.numOfAcquisitions";
        break;
      }
      case "management": {
        newHeader = "management.name";
        break;
      }
      case "numOfEmployees": {
        newHeader = "details.numOfEmployees.min";
        break;
      }
      case "phoneNumber": {
        newHeader = "details.phoneNumber";
        break;
      }
      case "operationalDuration": {
        newHeader = "details.year.lifespan";
        break;
      }
      case "foundedDate": {
        newHeader = "details.date.started";
        break;
      }
      case "shutdownDate": {
        newHeader = "details.date.ended";
        break;
      }
      default: {
        newHeader = header;
      }
    }
  }

  return newHeader;
};

export const getDetailedHeader = (collection, header) => {
  //update the argument state variable
  let newHeader;

  if (collection === "investors") {
    switch (header) {
      case "location": {
        newHeader = "location.city";
        break;
      }
      case "investmentRange": {
        newHeader = "investmentRange.totalNumOfStages";
        break;
      }
      case "investmentTrackRecord": {
        newHeader = "investmentTrackRecord.totalNumOfStages";
        break;
      }
      case "sweetSpot": {
        newHeader = "sweetSpot.totalNumOfStages";
        break;
      }
      case "management": {
        newHeader = "management.name";
        break;
      }
      case "boardMembers": {
        newHeader = "boardMembers.firstName";
        break;
      }
      case "lossOnInvestments": {
        newHeader = "lossOnInvestmentsObj.int";
        break;
      }
      case "numOfEmployeesObj": {
        newHeader = "numOfEmployeesObj.min";
        break;
      }
      case "website": {
        newHeader = "profileLink.url";
        break;
      }
      case "founded": {
        newHeader = "founded.dateOrder";
        break;
      }
      case "email": {
        newHeader = "contact.emails";
        break;
      }
      case "phone": {
        newHeader = "contact.phoneNumber";
        break;
      }
      case "address": {
        newHeader = "address.street1";
        break;
      }
      case "formerlegalName": {
        newHeader = "former_legalName";
        break;
      }
      default: {
        newHeader = header;
      }
    }
  } else {
    switch (header) {
      case "details.lastFinancingRound": {
        newHeader = "lastFinancingRound";
        break;
      }
      case "details.totalInvestment": {
        newHeader = "totalInvestment";
        break;
      }
      case "details.location.city": {
        newHeader = "location";
        break;
      }
      case "details.numOfFundingRounds": {
        newHeader = "numOfFundingRounds";
        break;
      }
      case "details.numOfInvestors.total": {
        newHeader = "numOfInvestors.total";
        break;
      }
      case "management.name": {
        newHeader = "name";
        break;
      }
      case "details.numOfEmployees.min": {
        newHeader = "numOfEmployees";
        break;
      }
      case "details.phoneNumber": {
        newHeader = "phoneNumber";
        break;
      }
      case "details.year.lifespan": {
        newHeader = "operationalDuration";
        break;
      }
      case "details.date.started": {
        newHeader = "foundedDate";
        break;
      }
      case "details.date.ended": {
        newHeader = "shutdownDate";
        break;
      }
      default: {
        newHeader = header;
      }
    }
  }

  return newHeader;
};

// function to scroll table
export const scrollToTop = (id) => {
  window.scrollTo(0, 0);
  document.getElementById(id).scrollIntoView();
};

export const fetchData = async ({ supabase, getData, dispatch, argument }) => {
  try {
    const { data: response, error } = await supabase.functions.invoke(getData, {
      body: argument,
    });

    if (error) {
      const ctx = await error.context?.json?.().catch(() => ({}));
      const msg = ctx?.error ?? "unknown";
      throw new Error(msg);
    }

    const pageCopy = {
      startNum: 1,
      endNum: response.results.length.toString(),
      lastPage: response.lastPage,
    };

    dispatch({
      type: "data_exists_after_fetching",
      tableData: response,
      page: { ...pageCopy },
    });
  } catch (err) {
    dispatch({ type: "show_fetching_error" });
  }
};

// filter function - the args/constructor are locales (en) language and options (numeric collation are set to true and sensitivity level set to base)
const collator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base",
});

export const getSortedResults = async (params) => {
  const { supabase, dispatch, getData, argument } = params;
  try {
    const { data: response, error } = await supabase.functions.invoke(getData, {
      body: argument,
    });
    if (error) {
      const ctx = await error.context?.json?.().catch(() => ({}));
      const msg = ctx?.error ?? "unknown";
      throw new Error(msg);
    }
    dispatch({
      type: "update_tableData",
      tableData: response,
    });
  } catch (err) {
    // show alert when error is received
    dispatch({ type: "show_sorting_error" });
  }
};

export const getFieldObj = (collection, name) => {
  if (collection === "companies") {
    return allCompaniesFields[
      allCompaniesFields.findIndex((field) => field.actualName === name)
    ];
  }

  if (collection === "investors") {
    return allInvestorsFields[
      allInvestorsFields.findIndex((field) => field.actualName === name)
    ];
  }
};

export const handleFieldHide = (props, field) => {
  const { dispatch } = props;

  dispatch({
    type: "update_state_when_hiding_fields",
    header: field.actualName,
  });
};

export const handleFieldUnhide = (props, id) => {
  const { dispatch } = props;

  dispatch({
    type: "remove_item_from_array",
    index: id,
    stateArray: "hiddenFieldNames",
  });
};

export const handleFieldSort = (props, field, value) => {
  const { dispatch, argument } = props;

  const sortConditionObj = {
    actualName: field.actualName,
    sortOrder: value,
    type: field.type,
  };

  // update array
  // dispatch({
  //   type: "update_array",
  //   stateArray: "sortConditionsArray",
  //   index: 0,
  //   newElement: sortConditionObj,
  // });

  const argumentCopy = {
    ...argument,
    selectedHeader: getNewHeader("companies", field.actualName),
    selectedDropdown: value,
  };

  //argument is updated
  dispatch({
    type: "update_state_when_sorting",
    argument: argumentCopy,
    fieldObj: sortConditionObj,
  });
};

export const selectedDropdown = async (props, value, header) => {
  const { tableData, state, dispatch } = props;

  let total = tableData.total;
  let sortedData = [...tableData.results];

  if (value === " Hide Field") {
    dispatch({ type: "update_state_when_hiding_fields", header: header });
  }

  if (header != null) {
    try {
      if (header === "lastFinancingDate") {
        if (value === " Sort older to newer") {
          sortedData.sort((a, b) => {
            let aa = new Date(a.details?.lastFinancingDate).getTime(),
              bb = new Date(b.details?.lastFinancingDate).getTime();
            return collator.compare(aa, bb);
          });
        }
        if (value === " Sort newer to older") {
          sortedData.sort((a, b) => {
            let aa = new Date(a.details?.lastFinancingDate).getTime(),
              bb = new Date(b.details?.lastFinancingDate).getTime();
            if (aa === b) {
              return 0;
            }
            if (aa === null) {
              return 1;
            }
            if (bb === null) {
              return -1;
            }
            return aa < bb ? 1 : -1;
          });
        }
      }
      if (header === "foundedDate" || header === "shutdownDate") {
        if (value === " Sort older to newer") {
          sortedData.sort((a, b) => {
            let aa = new Date(a.details.date?.started).getTime(),
              bb = new Date(b.details.date?.started).getTime();
            return collator.compare(aa, bb);
          });
        }
        if (value === " Sort newer to older") {
          sortedData.sort((a, b) => {
            let aa = new Date(a.details.date?.started).getTime(),
              bb = new Date(b.details.date?.started).getTime();
            if (aa === b) {
              return 0;
            }
            if (aa === null) {
              return 1;
            }
            if (bb === null) {
              return -1;
            }
            return aa < bb ? 1 : -1;
          });
        }
      }
    } catch {
      if (
        value === " Sort A to Z" ||
        value === " Sort smaller to larger" ||
        value === " Sort older to newer"
      ) {
        sortedData.sort((a, b) => {
          return collator.compare(a[header], b[header]);
        });
      }
      if (
        value === " Sort Z to A" ||
        value === " Sort larger to smaller" ||
        value === " Sort newer to older"
      ) {
        sortedData.sort((a, b) => {
          return collator.compare(b[header], a[header]);
        });
      }
    }
    dispatch({
      type: "update_state",
      state: "tableData",
      value: { ...state.tableData, results: sortedData, total: total },
    });

    dispatch({
      type: "update_state",
      state: "sortedFieldNames",
      value: [...state.sortedFieldNames, header],
    });
  }
};

// function to update hooks
export const changeFilters = async (e, params) => {
  const { supabase, dispatch, getData, argument, page, tableData } = params;

  e.preventDefault();

  let argumentCopy = { ...argument };
  let pageCopy = { ...page };

  let name = e.target.name;
  let value = e.target.value;

  // change current page value
  if (name.includes("Page")) {
    let currentPageName = "currentPage",
      currentPageValue,
      startNumName = "startNum",
      startNumValue,
      endNumName = "endNum",
      endNumValue;

    if (name === "firstPage") {
      currentPageValue = 1;
      startNumValue = 1;
      endNumValue = argument.numOfRows;
    }
    if (name === "prevPage") {
      // if prev page is the first page
      if (argument.currentPage - 1 === 1) {
        currentPageValue = 1;
        startNumValue = 1;
        endNumValue = argument.numOfRows;
      }
      // if prev page is not the last page
      else {
        currentPageValue = argument.currentPage - 1;
        startNumValue = (currentPageValue - 1) * argument.numOfRows + 1;
        endNumValue = currentPageValue * argument.numOfRows;
      }
    }
    if (name === "nextPage") {
      // if next page is the last page
      if (parseInt(argument.currentPage) + 1 === page.lastPage) {
        currentPageValue = page.lastPage;
        startNumValue = (currentPageValue - 1) * argument.numOfRows + 1;
        endNumValue = tableData.total;
      }
      // if next page is not the last page
      else {
        currentPageValue = parseInt(argument.currentPage) + 1;
        startNumValue = (currentPageValue - 1) * argument.numOfRows + 1;
        endNumValue = currentPageValue * argument.numOfRows;
      }
    }
    if (name === "lastPage") {
      currentPageValue = page.lastPage;
      startNumValue = (currentPageValue - 1) * argument.numOfRows + 1;
      endNumValue = tableData.total;
    }

    argumentCopy[currentPageName] = currentPageValue;
    pageCopy[startNumName] = startNumValue;
    pageCopy[endNumName] = endNumValue;
  }

  // if numOfRows is changed, then reset all values for pagination
  if (name === "numOfRows") {
    let lastPage = Math.ceil(tableData.total / value);

    argumentCopy["currentPage"] = 1;
    argumentCopy["numOfRows"] = value;
    pageCopy["startNum"] = 1;
    pageCopy["endNum"] = value;
    pageCopy["lastPage"] = lastPage;
  }

  // change search term value
  if (name === "searchTerm") {
    argumentCopy[name] = value;
    // update argument
    dispatch({
      type: "update_state",
      state: "argument",
      value: { ...argumentCopy },
    });
  }

  // only fetch data if numOfRows or currentPage is changed i.e) when pagination feature is used
  if (name.localeCompare("searchTerm") !== 0) {
    // update page state
    dispatch({
      type: "update_state_when_using_pagination",
      page: { ...pageCopy },
    });

    dispatch({ type: "loading", argument: { ...argumentCopy } });

    try {
      const { data: response, error } = await supabase.functions.invoke(
        getData,
        {
          body: argumentCopy,
        },
      );

      if (error) {
        const ctx = await error.context?.json?.().catch(() => ({}));
        const msg = ctx?.error ?? "unknown";
        throw new Error(msg);
      }

      dispatch({
        type: "data_exists_after_fetching",
        tableData: response,
        page: { ...pageCopy },
      });
    } catch (err) {
      dispatch({ type: "show_fetching_error" });
    }
  }
};

export const unhideFields = (params) => {
  const { dispatch, hiddenFieldNames } = params;
  dispatch({ type: "unhide_fields" });
  if (hiddenFieldNames) {
    hiddenFieldNames.length = 0;
  }
};

export const getAppliedFilterFieldNames = (argument) => {
  return argument["filter"]["conditions"].map((condition) =>
    getDetailedHeader("companies", condition.where.field),
  );
};

// function to submit search term
export const submitSearch = async (e, params) => {
  const { getData, state, dispatch, argument, supabase } = params;

  e.preventDefault();

  const argumentCopy = { ...argument };
  const searchTerm = argumentCopy.searchTerm;

  argumentCopy["currentPage"] = 1;
  argumentCopy["filter"]["conditions"].length === 0
    ? (argumentCopy["filter"]["applied"] = false)
    : (argumentCopy["filter"]["applied"] = true);

  dispatch({ type: "loading", argument: { ...argumentCopy } });
  dispatch({
    type: "update_filtered_fields_applied",
    argument: { ...argumentCopy },
  });

  try {
    // console.log("filter/search argument:", argumentCopy);
    const { data: response, error } = await supabase.functions.invoke(getData, {
      body: argumentCopy,
    });

    if (error) {
      const ctx = await error.context?.json?.().catch(() => ({}));
      const msg = ctx?.error ?? "unknown";
      throw new Error(msg);
    }

    const pageCopy = {
      startNum: 1,
      endNum: response.results.length.toString(),
      lastPage: response.lastPage,
    };

    if (response.total === 0) {
      dispatch({
        type: "no_data_after_fetching",
        tableData: response,
        page: { ...pageCopy },
      });
    } else {
      dispatch({
        type: "data_exists_after_fetching",
        tableData: response,
        page: { ...pageCopy },
      });

      dispatch({
        type: "search_applied",
        searchTerm: searchTerm,
      });
    }
  } catch (err) {
    dispatch({ type: "show_fetching_error" });
  }
};

// function to listen to keyboard
export const enterSearch = async (e, params) => {
  if (e.code === "Enter" || e.code === "NumpadEnter") {
    submitSearch(e, params);
  }
};

// function to reset search term only
export const resetSearch = async (e, params) => {
  const { getData, dispatch, argument, supabase } = params;

  e.preventDefault();

  const argumentCopy = { ...argument };
  argumentCopy["searchTerm"] = "";
  argumentCopy["currentPage"] = 1;

  dispatch({ type: "loading", argument: { ...argumentCopy } });

  try {
    const { data: response, error } = await supabase.functions.invoke(getData, {
      body: argumentCopy,
    });

    if (error) {
      const ctx = await error.context?.json?.().catch(() => ({}));
      const msg = ctx?.error ?? "unknown";
      throw new Error(msg);
    }

    const pageCopy = {
      startNum: 1,
      endNum: response.results.length.toString(),
      lastPage: response.lastPage,
    };

    dispatch({
      type: "data_exists_after_fetching",
      tableData: response,
      page: { ...pageCopy },
    });

    dispatch({
      type: "update_state",
      state: "searchApplied",
      value: false,
    });

    dispatch({
      type: "update_state",
      state: "searchTermApplied",
      value: "",
    });
  } catch (err) {
    dispatch({ type: "show_fetching_error" });
  }
};

// function to reset filter only
export const resetFilter = async (e, params) => {
  const { getData, dispatch, argument, supabase } = params;

  e.preventDefault();

  const argumentCopy = {
    ...argument,
    currentPage: 1,
    filter: { connective: "and", conditions: [], applied: false },
  };

  dispatch({ type: "clear_filtered_fields_applied" });

  dispatch({ type: "loading", argument: { ...argumentCopy } });
  try {
    const { data: response, error } = await supabase.functions.invoke(getData, {
      body: argumentCopy,
    });

    if (error) {
      const ctx = await error.context?.json?.().catch(() => ({}));
      const msg = ctx?.error ?? "unknown";
      throw new Error(msg);
    }

    const pageCopy = {
      startNum: 1,
      endNum: response.results.length.toString(),
      lastPage: response.lastPage,
    };

    dispatch({
      type: "data_exists_after_fetching",
      tableData: response,
      page: { ...pageCopy },
    });
  } catch (err) {
    dispatch({ type: "show_fetching_error" });
  }
};

// function to reset search term and filters
export const resetTable = async (e, params) => {
  const { getData, dispatch, supabase } = params;

  e.preventDefault();

  const argumentCopy = {
    numOfRows: 50,
    currentPage: 1,
    searchTerm: "",
    selectedHeader: "",
    selectedDropdown: "",
    filter: {
      connective: "and",
      conditions: [],
      applied: false,
    },
  };

  // clear filter conditions array
  dispatch({ type: "reset_table" });

  try {
    // console.log("reset all argument:", argument);
    const { data: response, error } = await supabase.functions.invoke(getData, {
      body: argumentCopy,
    });

    if (error) {
      const ctx = await error.context?.json?.().catch(() => ({}));
      const msg = ctx?.error ?? "unknown";
      throw new Error(msg);
    }

    const pageCopy = {
      startNum: 1,
      endNum: response.results.length.toString(),
      lastPage: response.lastPage,
    };

    dispatch({
      type: "data_exists_after_fetching",
      tableData: response,
      page: { ...pageCopy },
    });
  } catch (err) {
    dispatch({ type: "show_fetching_error" });
    // console.log("err", err);
  }
};

// merge two arrays of objects together based on key
function mergeArraysOfObjectsByKey(array1, array2, key) {
  const mergedArray = [];

  // iterate over the first array
  array1.forEach((object1) => {
    // find the corresponding object in the second array
    const object2 = array2.find((object2) => object2[key] === object1[key]);

    // if there is a corresponding object in the second array, merge the two objects
    if (object2) {
      const mergedObject = Object.assign({}, object1, object2);
      mergedArray.push(mergedObject);
    } else {
      // if there is no corresponding object in the second array, just add the first object to the merged array
      mergedArray.push(object1);
    }
  });

  return mergedArray;
}

// function to fetch more details for expand modal
export const getCompanyDetails = async (e, params) => {
  const { getCompanyDetailsForExpand, dispatch } = params;

  dispatch({ type: "load_company_detail" });

  try {
    const response = await getCompanyDetailsForExpand(e);
    const array1 = response[0].companies;
    const array2 = response[0].details;

    let mergedArray;
    let data;

    if (e.field === "competitors" || e.field === "similarEntities") {
      data = array2;
    } else {
      mergedArray = mergeArraysOfObjectsByKey(array1, array2, "name");
      data = mergedArray;
    }

    dispatch({ type: "show_expand_data", data: data });
  } catch (err) {
    // To-do: Alert user an error was returned
    // console.error(err);
    const error = "There was an error fetching the data";
    dispatch({ type: "show_expand_data", data: error });
  }
  // close alert
  // closeAlert();
};

export const handleData = (e, params) => {
  const { tableData, dispatch } = params;

  try {
    const newData = tableData.results
      .filter((companies) => companies.tradeName === e)
      .map(
        (companies) =>
          (companies = {
            slug: companies.slug,
            name: companies.name,
            tradeName: companies.tradeName,
            description: companies.description,
            logo: companies.logo,
            reasonsForFailure: companies.reasonsForFailure,
            categories: companies.categories,
            location: companies.details.location,
            country: companies.details.location.country,
            countryCode: companies.details.location.countryCode,
            state: companies.details.location.state,
            city: companies.details.location.city,
            industry: companies.industry,
            products: companies.products,
          }),
      );

    dispatch({ type: "show_more_info_data", data: newData });
  } catch (error) {
    const newData = tableData.results
      .filter((companies) => companies.tradeName === e)
      .map(
        (companies) =>
          (companies = {
            slug: companies.slug,
            name: companies.name,
            tradeName: companies.tradeName,
            description: companies.description,
            logo: companies.logo,
            reasonsForFailure: companies.reasonsForFailure,
            categories: companies.categories,
            industry: companies.industry,
            products: companies.products,
          }),
      );

    dispatch({ type: "show_more_info_data", data: newData });
  }
};

// function to close alert component
export const closeAlert = (params) => {
  const { dispatch } = params;

  dispatch({ type: "close_alert" });
};

// function to open expand modal
export const openExpandCard = (e, params) => {
  const { dispatch } = params;

  dispatch({ type: "show_expand_data", data: e });
};

// function to open expand modal
export const closeExpandCard = (params) => {
  const { dispatch } = params;

  dispatch({ type: "close_expand_data_card" });
};

// function to open expand modal
export const closeMoreInfoCard = (params) => {
  const { dispatch } = params;

  dispatch({ type: "close_more_info_card" });
};

export const capitalize = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

export function extractGclid() {
  const gclAw = getCookie("_gcl_aw");
  if (!gclAw) return null;

  const parts = gclAw.split(".");
  return parts.length >= 3 ? parts[2] : null;
}
